import { DivestitureDiagnosticUtility } from '@pwc/pwc-deals-web-common';
import React from 'react';
import './Score.scss';

const Score = ({ value, scoreType, minified }) => (
  <span className="diagnostic-category-score">
    {`${DivestitureDiagnosticUtility.calculateScoreText(
      value,
      minified
    )}${DivestitureDiagnosticUtility.getScoreTitle(scoreType)}: ${value}`}
  </span>
);

export default Score;
